export default __webpack_public_path__ + "195bbf8ab50ab1a452eada2ad9d5a2c4.png";